"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _productPositionSelectors = require("../../redux/selectors/productPositionSelectors");
var _snackbarActions = require("../../redux/actions/snackbarActions");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _level1Actions = require("../../redux/actions/level1Actions");
var _level2Actions = require("../../redux/actions/level2Actions");
var _instrumentActions = require("../../redux/actions/instrumentActions");
var _StreamingCardGridComponent = _interopRequireDefault(require("./StreamingCardGridComponent"));
var _filterSortSupportedInstruments = _interopRequireDefault(require("../../helpers/filterSortSupportedInstruments"));
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var streamingForm = 'StreamingForm';
var StreamingInstruments = _config["default"].StreamingInstruments;
var filterInstruments = function filterInstruments(allInstruments) {
  var standardInstruments = (0, _filterSortSupportedInstruments["default"])(allInstruments);
  var displaySymbols = StreamingInstruments.Symbol;
  if (displaySymbols.length) {
    return standardInstruments.filter(function (i) {
      return displaySymbols.includes(i.Symbol);
    });
  }
  return standardInstruments;
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    fetching: (0, _productPositionSelectors.fetchingSelector)(state),
    state: state,
    products: (0, _productPositionSelectors.fundedPositionsSelector)(state),
    instruments: filterInstruments((0, _instrumentPositionSelectors.instrumentsWithProductFullNamesAndProductSymbols)(state)),
    level1: state.apexCore.level1,
    productManifest: state.productManifest,
    formData: state.form[streamingForm],
    AccountId: state.user.selectedAccountId,
    selectedInstrumentId: state.apexCore.instrument.selectedInstrumentId,
    additionalSlipage: StreamingInstruments.additionalSlippage
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setInstrument: function setInstrument(payload) {
      dispatch((0, _instrumentActions.setInstrument)(payload.instrumentId));
      localStorage.setItem('selectedInstrumentId', payload.instrumentId);
      // resubscribe to level2
      dispatch((0, _level1Actions.subscribeToLevel1)(payload.instrumentId));
      dispatch((0, _level2Actions.subscribeToLevel2)(payload.instrumentId));
    },
    getLevel1Data: function getLevel1Data(InstrumentId) {
      return dispatch((0, _level1Actions.getLevel1Data)(InstrumentId));
    },
    unsubscribeLevel1: function unsubscribeLevel1(InstrumentId) {
      return dispatch((0, _level1Actions.unsubscribeLevel1)(InstrumentId));
    },
    subscribeToLevel1: function subscribeToLevel1(InstrumentId) {
      return dispatch((0, _level1Actions.subscribeToLevel1)(InstrumentId));
    },
    changeReduxForm: function changeReduxForm(payload) {
      return dispatch((0, _reduxForm.change)(streamingForm, payload.field, payload.value));
    },
    showNotification: function showNotification(message) {
      dispatch((0, _snackbarActions.showSnack)({
        id: 'validationNotification',
        text: message,
        type: 'warning'
      }));
    }
  };
};
var StreamingCardGridContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_StreamingCardGridComponent["default"]);
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  form: streamingForm,
  enableReinitialize: true
})(StreamingCardGridContainer);